<div class="product-badge" [ngClass]="{ 'primary-badge': priority === 'primary', 'secondary-badge': priority === 'secondary' }">
  <label>{{ text }}</label>
</div>
